var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIdIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2578",
    "data-name": "Group 2578",
    transform: "translate(-370 -470)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_151",
    "data-name": "Ellipse 151",
    cx: 36,
    cy: 36,
    r: 36,
    transform: "translate(370 470)",
    fill: "#3381f2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "noun-business-contact-1236153",
    transform: "translate(280.594 411.557)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_610",
    "data-name": "Path 610",
    d: "M139.467,78.4H110.344a4.9,4.9,0,0,0-4.9,4.9v22.285a4.9,4.9,0,0,0,4.9,4.9h29.122a4.9,4.9,0,0,0,4.9-4.9V83.3a4.9,4.9,0,0,0-4.9-4.9Zm2.228,27.187a2.229,2.229,0,0,1-2.228,2.228H110.344a2.228,2.228,0,0,1-2.228-2.228V83.3a2.229,2.229,0,0,1,2.228-2.228h29.122A2.229,2.229,0,0,1,141.7,83.3Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_611",
    "data-name": "Path 611",
    d: "M390.228,260.4h-9.711a1.337,1.337,0,1,0,0,2.674h9.711a1.337,1.337,0,1,0,0-2.674Z",
    transform: "translate(-251.951 -167.517)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_612",
    "data-name": "Path 612",
    d: "M380.516,195.873h4.809a1.337,1.337,0,1,0,0-2.674h-4.809a1.337,1.337,0,0,0,0,2.674Z",
    transform: "translate(-251.951 -105.664)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_613",
    "data-name": "Path 613",
    d: "M218.527,191.419a3.7,3.7,0,1,1-3.7-3.7,3.7,3.7,0,0,1,3.7,3.7",
    transform: "translate(-97.267 -100.617)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_614",
    "data-name": "Path 614",
    d: "M182.869,302.365a7.194,7.194,0,0,0-6.467,3.708v1.854h12.97v-1.854a7.193,7.193,0,0,0-6.5-3.708Z",
    transform: "translate(-65.312 -206.139)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_615",
    "data-name": "Path 615",
    d: "M390.228,327.6h-9.711a1.337,1.337,0,1,0,0,2.674h9.711a1.337,1.337,0,1,0,0-2.674Z",
    transform: "translate(-251.951 -229.368)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdIcon);
export default __webpack_public_path__ + "static/media/id-icon.195486533a0da453b250010c2ab6097e.svg";
export { ForwardRef as ReactComponent };